/**
 * 「パルの おてつだい」の せってい(docs/07_learning_support.md §7.4)。
 *
 * **既定はオン**。まなびで手が止まったときのヒントと、タイピングの応援を
 * まとめて入り切りする。オフにすると
 *   - 詰まり検知の吹き出し(L0 励まし / L1 着眼点 / L2 考え方)
 *   - 「かいせつを もういちど みる」「こたえを みる」のボタン
 *   - タイピングの応援
 * が**ぜんぶ出なくなる**(docs/07 §3.4「介入頻度に上限、設定でOFF/控えめ可」)。
 *
 * ひとりで じっくり 考えたい子のための逃げ道なので、
 * オフの文言も「がまん」ではなく「じぶんの ちからで」にする。
 */

import { useGameStore } from '../store/gameStore';

export function PalHelpSettings() {
  const on = useGameStore((state) => state.settings.palHelp);
  const toggle = useGameStore((state) => state.togglePalHelp);

  return (
    <section className="card pal-settings" data-testid="pal-help-settings">
      <h2 className="card-title">🤝 パルの おてつだい</h2>
      <label className={`pal-settings-check ${on ? 'on' : ''}`}>
        <input type="checkbox" checked={on} onChange={toggle} />
        こまった ときに パルが ヒントを くれる
      </label>
      <p className="pal-settings-note">
        {on
          ? 'てが とまったら パルが こえを かけて、ヒントを 出すよ。'
          : 'いまは パルは だまって みてるよ。じぶんの ちからで やって みよう!'}
      </p>
    </section>
  );
}
